import React from 'react';
import styles from './AvatarGallery.module.css';

// Main Avatar Gallery component
const AvatarGallery = ({ onSelectAvatar, avatars, isLoadingAvatars, avatarError }) => {
  const defaultAvatars = avatars.filter(avatar => avatar.isDefault);
  const customAvatars = avatars.filter(avatar => !avatar.isDefault);

  return (
    <div className={styles.container}>
      <h2 className={styles.sectionHeading}>Interactive Avatars</h2>
      <div className={styles.galleryLayout}>
        {avatarError && (
          <div className={styles.errorText}>
            <p>{avatarError}</p>
          </div>
        )}
        <div className={styles.avatarSection}>
          <h3 className={styles.subSectionHeading}>My Avatars</h3>
          <MyAvatarsSection
            avatars={customAvatars}
            isLoadingAvatars={isLoadingAvatars}
            onSelectAvatar={onSelectAvatar}
            />
        </div>
        <div className={styles.divider}></div>
        <div className={styles.avatarSection}>
          <h3 className={styles.subSectionHeading}>Default Avatars</h3>
          <DefaultAvatarsSection 
            avatars={defaultAvatars}
            isLoadingAvatars={isLoadingAvatars}
            onSelectAvatar={onSelectAvatar}
            />
        </div>
      </div>
    </div>
  );
};

// My Avatars Section
const MyAvatarsSection = ({ onSelectAvatar, avatars, isLoadingAvatars }) => {
  if (isLoadingAvatars) {
    return (
      <div className={styles.loadingContainer}>
        <p className={styles.loadingText}>Loading avatars...</p>
      </div>
    );
  }

  return (
    <>
      {avatars?.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No custom avatars found.</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {avatars?.map(avatar => (
            <AvatarCard 
              key={avatar.id} 
              avatar={avatar} 
              onSelect={() => onSelectAvatar(avatar)} 
            />
          ))}
        </div>
      )}
    </>
  );
};

// Default Avatars Section
const DefaultAvatarsSection = ({ onSelectAvatar, avatars, isLoadingAvatars }) => {
  if (isLoadingAvatars) {
    return (
      <div className={styles.loadingContainer}>
        <p className={styles.loadingText}>Loading default avatars...</p>
      </div>
    );
  }

  return (
    <>
      {avatars?.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No default avatars available.</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {avatars?.map(avatar => (
            <AvatarCard 
              key={avatar.id} 
              avatar={avatar} 
              onSelect={() => onSelectAvatar(avatar)} 
            />
          ))}
        </div>
      )}
    </>
  );
};

// Avatar Card component
const AvatarCard = ({ avatar, onSelect }) => {
  const { avatar_name, image_url } = avatar;
  
  return (
    <div className={styles.avatarCard}>
      <div className={styles.imageContainer}>
        <img 
          src={image_url} 
          alt={avatar_name} 
          className={styles.avatarImage}
          onError={(e) => {
            // Fallback if image fails to load
            e.target.src = 'https://via.placeholder.com/100?text=Avatar';
          }}
        />
        <div className={styles.menuDots}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
        <div className={styles.chatButtonContainer}>
          <button className={styles.chatButton} onClick={onSelect}>
            <span className={styles.chatIcon}>💬</span>
            Chat
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvatarGallery;
